import romanApi from "@roman/shared/lib/net/romanApi";
import type { PredictionMarketWithProbability } from "@roman/shared/types/PredictionMarket";
import useSWR, { type SWRConfiguration } from "swr";

type GetRelatedPredictionMarketsResponse = {
  relatedPredictionMarkets: (PredictionMarketWithProbability & { totalEnteredFreePoints: number })[];
};

export type GetRelatedPredictionMarketsProps = {
  label: string;
  id: string;
  swrOptions?: SWRConfiguration;
  fetcher?: (url: string) => Promise<GetRelatedPredictionMarketsResponse>;
};

export const createDefaultGetRelatedPredictionMarketsFetcher = () => {
  return (url: string) => romanApi.get<GetRelatedPredictionMarketsResponse>(url, undefined);
};

export const useGetRelatedRecentPredictionMarkets = ({
  label,
  id,
  swrOptions,
  fetcher,
}: GetRelatedPredictionMarketsProps) => {
  const resultFetcher = fetcher || createDefaultGetRelatedPredictionMarketsFetcher();

  const swrQuery = useSWR(
    `/prediction-market/related-recent/?label=${label}&id=${id}`,
    (url: string) => resultFetcher(url),
    swrOptions,
  );

  return {
    relatedPredictionMarkets: swrQuery.data?.relatedPredictionMarkets ?? [],
    ...swrQuery,
  };
};
